import { connect } from 'react-redux';
import Image from 'brastrap/common/image/Image';

const mapStateToProps = state => ({
  deviceIs: state.browser.deviceIs,
});

export default connect(mapStateToProps)(Image);
